/**
 * CenterPointToggle — show/hide the location center (scene origin) marker.
 */
import { Crosshair } from 'lucide-react'
import { ToolbarButton } from './ToolbarButton'

interface Props {
  active: boolean
  onToggle: () => void
  fullWidth?: boolean
}

export function CenterPointToggle({ active, onToggle, fullWidth }: Props) {
  return (
    <ToolbarButton
      icon={<Crosshair className="h-4 w-4" />}
      label="Center"
      accent="fuchsia"
      active={active}
      fullWidth={fullWidth}
      onClick={onToggle}
      title="Toggle the location center point (scene origin)"
    />
  )
}
